import { Prev } from "react-bootstrap/esm/PageItem";
import { Link, useNavigate } from "react-router-dom";
import { delete_size_row } from "../../reduxData/user/userAction";
import { useSelector } from "react-redux";
import { memo, useState } from "react";
import DeletePopup from "../../Modals/DeletePopup";

const FrontTable = memo(({
  frontTableData,
  setEditRow,
  setApi,
  setSelectedGender,
  setSelectedCategory,
  setSelectedBrand,
  setDefaultText,
  // setSelectedSizeCategory,
  setOpen,
  handleDeleteRow,
  setDisableCategory,
  setSelectedSizeRegion,
  setDisableFields
}) => {
// const navigate = useNavigate();
const {user} = useSelector(state=>state.auth);
  const [openDeletePopup ,setOpenDeletePopup] = useState(false);
  const [firstRowId, setFirstRowId] = useState("");

  const handleCategoryName =(data)=>{
  
    const filterData  = data?.map(i=>i?.id=="0"?"Default":i?.category_name);
    return filterData?.join(", ");
  }

  const handleDelete = ()=>{
    
    handleDeleteRow(firstRowId);
     setFirstRowId("");
     setOpenDeletePopup(false);
  }

  return (
    <div className="mt-2 size-table ">
      <table className="table-size ">
        <thead>
          <tr className="table-head">
            <th className="p-md-3 text-start p-1 text-nowrap">Sr No .</th>
            <th className="p-md-3 text-start p-1 text-nowrap">Product Category</th>
            <th className="p-md-3 text-start p-1 text-nowrap">Brand</th>
            <th className="p-md-3 text-start p-1 text-nowrap">Gender</th>
            {/* <th className="p-md-3 text-start p-1 text-nowrap">Category</th> */}
            <th className="text-start p-md-3 p-1 text-nowrap">Action</th>
          </tr>
        </thead>
        <tbody>
          {frontTableData?.length > 0 ? (
            frontTableData?.map((i, idx) => (
              <tr className="" key={i?.id}>
                <td className="fs-6 fw-semibold text-nowrap ">{idx + 1}</td>
                <td className="fs-6 fw-semibold text-nowrap">{i?.product_type_name}</td>
                <td className="fs-6 fw-semibold text-nowrap">{i?.brand_name || "Default"}</td>
                <td className="fs-6 fw-semibold text-nowrap">{i?.gender_name}</td>
                {/* <td className="fs-6 fw-semibold text-nowrap">{handleCategoryName(i?.category_ids)|| "-"}</td> */}
                <td className="text-nowrap"> 
                  <Link
                    to={`/view-size/${i?.type_id}/${i?.brand_id}/${i?.gender_id}`}

                    // to={`/edit-product/${i?.product_category_id}/${i.id}`}
                    // onClick={() => {
                      // setView(true);
                      // setSelectedBrand(i?.brand_id);
                      // setSelectedCategory(i?.type_id);
                      // setSelectedGender(i?.gender_id);
                      // setSelectedSizeRegion(i?.region_id || []);
                      // Categories will be extracted from size_with_price API response
                      // setSelectedSizeCategory will be set automatically via useEffect in Sizes.js
                      // setNames({
                      //   gender: i?.gender_name,
                      //   type: i?.product_type_name,
                      //   brand: i?.brand_name,
                      // });
                    //   navigate(`view-sizes/${i?.type_id}/${i?.brand_id}/${i?.gender_id}`)
                    // }}
                  >
                    <i class="bi bi-eye mx-1 " ></i> 
                  </Link>
                 <Link  className="navbar-brand mx-1 text-success"><i className="far fa-edit edit" onClick={() => {
                      setOpen(prev => !prev)
                      setEditRow(true);
                      setApi("edit")
                      setDisableCategory(prev => !prev);
                      setSelectedBrand(i?.brand_id);
                      setSelectedCategory(i?.type_id);
                      setSelectedGender(i?.gender_id);
                      setSelectedSizeRegion(i?.region_id);
                      setDefaultText("Edit the Size Chart");
                      setDisableFields(false)
                      // setSizeCategoryIds(i?.category_ids|| [])

                    }}></i></Link>
                  {user?.role!="store-manager" && <Link
                    className="text-danger mx-1"
                    onClick={() => {
                      // handleDeleteRow(i)
                      setOpenDeletePopup(true);
                      setFirstRowId(i)
                    }}
                  >
                    <i className="bi bi-trash3"></i>
                  </Link>}
                  <Link>
                    <i className="bi bi-copy mx-1 text-info" onClick={() => {
                      setOpen(prev => !prev)
                      setApi("add")
                      setDisableCategory(true);
                      setSelectedBrand(i?.brand_id);
                      setEditRow(true)
                      setSelectedCategory(i?.type_id);
                      setSelectedGender(i?.gender_id);
                      setSelectedSizeRegion(i?.region_id);
                      setDisableFields(true);
                      setDefaultText("Dublicate the size chart")
                      // setSizeCategoryIds(i?.category_ids|| [])

                    }}></i>
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan={6} className="text-center">No data !</td> </tr>
          )}
        </tbody>
      </table>
      {openDeletePopup && <DeletePopup open={openDeletePopup} setOpen={setOpenDeletePopup}
      label="Are you sure , you want to delete " handleDelete={handleDelete}/>}
    </div>
  );
});

export default FrontTable;
